import { configureStore } from "@reduxjs/toolkit";
import navbar from "./navbar";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import sidebar from "./sidebar";
import userRole from "./userRole";
import examReducer from "./examSlice";
import subscriptionReducer from "./subscriptionSlice";
import categoriesReducer from "./categoriesSlice";
import practiceSet from "./practiceSet";
import testSet from "./testSet";
import invalidDialog from "./invalidDialog";
import fullLengthExam from "./fullLengthExam";
import ieltsAttemptReducer from "./ieltsAttemptSlice";
import paginationReducer from "./paginationSlice";
import tabReducer from "./tabSlice";
import folderReducer from "./folderSlice";
import adminDashboardReducer from "./adminDashboardSlice";

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  blacklist: ["navbar", "invalidDialog", "pagination"],
};

const reducer = combineReducers({
  // use this navbar name to use the values in selectors
  tab: tabReducer,
  pagination: paginationReducer,
  folder: folderReducer,
  navbar,
  sidebar,
  userRole,
  exam: examReducer,
  subscription: subscriptionReducer,
  categories: categoriesReducer,
  practiceSet,
  testSet,
  invalidDialog,
  fullLengthExam,
  ieltsAttempt: ieltsAttemptReducer,
  adminDashboard: adminDashboardReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(thunk),
});

export const persistor = persistStore(store);
